<div *ngIf="skillsByType as sbt">
  <ng-container *ngIf="getSkillTypeNames().length > 0; else noResults">
    <div
      *ngFor="
        let skillTypeName of getSkillTypeNames();
        trackBy: trackBySkillTypeName
      "
    >
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ skillTypeName }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-chip-listbox
          *ngIf="!thingspaceDraggableList"
          [hideSingleSelectionIndicator]="true"
        >
          <mat-chip-option
            class="skill-chip"
            *ngFor="
              let skill of getSkillsForType(skillTypeName);
              trackBy: trackBySkill
            "
            [selected]="isSelected(skill)"
            [ngClass]="{
              'skill-chip--selected': isSelected(skill),
              'skill-chip--related': isSkillRelated(
                skill,
                selectedSkillRelatedSkills
              )
            }"
            (click)="selectSkill(skill)"
          >
            <div class="skill-chip-container">
              <span class="skill-chip-label">{{ skill.Name }}</span>

              <mat-icon
                *ngIf="isSelected(skill)"
                class="skill-chip-check"
                aria-hidden="true"
              >
                check
              </mat-icon>
            </div>
          </mat-chip-option>
        </mat-chip-listbox>

        <mat-chip-listbox *ngIf="thingspaceDraggableList">
          <mat-chip-option
            class="skill-chip"
            mwlDraggable
            *ngFor="
              let skill of getSkillsForType(skillTypeName);
              let i = index;
              trackBy: trackBySkill
            "
            [dropData]="skill"
            dragActiveClass="drag-active"
          >
            {{ skill.Name }}
          </mat-chip-option>
        </mat-chip-listbox>
      </mat-expansion-panel>

      <br />
    </div>
  </ng-container>

  <ng-template #noResults>
    <div class="skill-list-empty-state" data-test="skill-list-empty">
      No skills match this search.
      <span class="muted">Try clearing the search box.</span>
    </div>
  </ng-template>
</div>
